import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-vsr-how-it-works.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "How It Works: Streamline Your Solar Sales Funnel";

const sections = [
  {
    title: "Qualify Leads 24/7 Through Your Website or Campaigns",
    description:
      "When homeowners visit your website or marketing destination, Enerflo VSR guides them through an interactive form that captures their name, address, utility bill, energy usage and can even pre-qualify using your active lenders.",
  },
  {
    title: "Provide Instant Quotes for Homeowners",
    description:
      "In real time, VSR generates a personalized solar quote estimate based on the customer’s information — giving homeowners instant insight while you receive a fully qualified lead.",
  },
  {
    title: "Leads Sync Seamlessly to Your Enerflo Deals Pipeline",
    description:
      "Every prospect flows directly into your Enerflo platform, ensuring fast follow-up and no lost opportunities. It’s like adding a full inside sales team to your business — without increasing headcount.",
  },
];

const StreamlineSalesFunnel = () => (
  <HeroSection title={title} className="sm:py-16 lg:py-20">
    <div className="grow flex flex-col items-center">
      <HeroSection.Content className="w-full md:text-center mb-16">
        <HeroSection.Header>
          <Heading tag="h2" className="text-navy">
            {title}
          </Heading>
        </HeroSection.Header>
      </HeroSection.Content>
      <HeroSection.Content className="w-full flex flex-col lg:text-left lg:flex-row gap-10">
        <div className="flex-1 space-y-8">
          {sections.map(item => (
            <div key={item.title} className="space-y-2">
              <Heading tag="h4" size="h5" className="text-navy">
                {item.title}
              </Heading>
              <p className="text-gray-500">{item.description}</p>
            </div>
          ))}
        </div>

        <figure className="flex-1 w-full xs:w-4/5 sm:w-3/4 lg:w-full mx-auto">
          <Image
            src={FigureImage}
            alt="How Enerflo VSR Works: Streamline Your Solar Sales Funnel."
            layout="responsive"
            quality={100}
            placeholder="blur"
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </figure>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default StreamlineSalesFunnel;
